'use client';

import React from 'react';
import Layout from '../../components/Layout';
import SubDocsLayout from '../../components/SubDocsLayout';
import useTranslation from '../../lib/translation';
import SEOHead from '../../components/SEOHead';

const MobileResponsive = () => {
  const { t, lang } = useTranslation('common');

  return (
    <Layout>
      <SEOHead
        title={
          lang === 'lt'
            ? Array.isArray(t('mobileResponsive.pageTitle')) ? (t('mobileResponsive.pageTitle') as string[]).join(' ') : (t('mobileResponsive.pageTitle') as string)
            : 'Mobile Responsive | LB Websites'
        }
        description={
          lang === 'lt'
            ? Array.isArray(t('mobileResponsive.description')) ? (t('mobileResponsive.description') as string[]).join(' ') : (t('mobileResponsive.description') as string)
            : 'LB Websites are fully mobile responsive, delivering flawless performance and accessibility on all screen sizes.'
        }
        keywords='mobile responsive design, mobile optimization, responsive websites, mobile-friendly, smartphone optimization, tablet design'
        canonicalUrl={
          lang === 'lt' ? '/lt/sub/mobili-versija' : '/sub/mobile-responsive'
        }
        lang={lang}
        structuredData={{
          '@context': 'https://schema.org',
          '@type': 'Service',
          name:
            lang === 'lt'
              ? Array.isArray(t('mobileResponsive.pageTitle')) ? (t('mobileResponsive.pageTitle') as string[]).join(' ') : (t('mobileResponsive.pageTitle') as string)
              : 'Mobile Responsive | LB Websites',
          description:
            lang === 'lt'
              ? Array.isArray(t('mobileResponsive.description')) ? (t('mobileResponsive.description') as string[]).join(' ') : (t('mobileResponsive.description') as string)
              : 'LB Websites are fully mobile responsive, delivering flawless performance and accessibility on all screen sizes.',
          url: `https://www.lbvisible.com${
            lang === 'lt'
              ? '/lt/sub/mobili-versija'
              : '/sub/mobile-responsive'
          }`,
          inLanguage: lang === 'lt' ? 'lt' : 'en',
          provider: {
            '@type': 'Organization',
            name: 'LB Visible',
          },
        }}
      />

      <SubDocsLayout>
        <h1 className='text-2xl sm:text-3xl font-semibold text-gray-900 dark:text-white mb-4 text-left'>
          {lang === 'lt' ? t('mobileResponsive.heading') : 'Mobile Responsive'}
        </h1>
        <p className='text-base text-gray-600 dark:text-gray-300 mb-10 text-left leading-relaxed'>
            {lang === 'lt'
              ? t('mobileResponsive.subtitle')
              : "Today's users browse from phones, tablets, and laptops. We build every website to adapt to any screen, giving your visitors a flawless experience wherever they are."}
          </p>

          <ul className='space-y-6'>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>
                {lang === 'lt'
                  ? t('mobileResponsive.benefits.userExperience.title')
                  : 'Better user experience:'}
              </span>{' '}
              {lang === 'lt'
                ? t('mobileResponsive.benefits.userExperience.desc')
                : 'Your site remains easy to navigate and visually appealing across all devices.'}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>
                {lang === 'lt'
                  ? t('mobileResponsive.benefits.seoRankings.title')
                  : 'Improved SEO rankings:'}
              </span>{' '}
              {lang === 'lt'
                ? t('mobileResponsive.benefits.seoRankings.desc')
                : 'Google favors mobile-friendly websites in search results.'}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>
                {lang === 'lt'
                  ? t('mobileResponsive.benefits.accessibility.title')
                  : 'Increased accessibility:'}
              </span>{' '}
              {lang === 'lt'
                ? t('mobileResponsive.benefits.accessibility.desc')
                : 'Reach more people, including mobile-first users and those with accessibility needs.'}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>
                {lang === 'lt'
                  ? t('mobileResponsive.benefits.brandReputation.title')
                  : 'Stronger brand reputation:'}
              </span>{' '}
              {lang === 'lt'
                ? t('mobileResponsive.benefits.brandReputation.desc')
                : 'A professional, consistent design builds trust and credibility.'}
              </div>
            </li>
            <li className='flex gap-4'>
              <span className='flex-shrink-0 w-2 h-2 rounded-full mt-2 bg-gray-400 dark:bg-gray-500' />
              <div>
              <span className='font-semibold text-gray-900 dark:text-white'>
                {lang === 'lt'
                  ? t('mobileResponsive.benefits.conversions.title')
                  : 'Higher conversions:'}
              </span>{' '}
              {lang === 'lt'
                ? t('mobileResponsive.benefits.conversions.desc')
                : 'Responsive design helps drive more leads, sales, and customer engagement.'}
              </div>
            </li>
          </ul>
      </SubDocsLayout>
    </Layout>
  );
};

export default MobileResponsive;
